import { HelpDeskService } from "../HelpdeskService/helpdesk.service"
import { HelpDeskDelegate } from "../HelpdeskService/helpdesk.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';

export class HelpDeskServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): HelpDeskService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new HelpDeskDelegate(httpProvider);

        return new HelpDeskService(delegate, authenticationService);
    }
}